import { Link } from 'react-router-dom';
import './Button.css';

const EditorialButton = ({ label, to = "/alla-fastigheter" }) => {
  return (
    <Link to={to} className="mag-btn-clean">
      <span className="mag-btn-text">
        {label}
        <div className="mag-btn-underline"></div>
      </span>
    </Link>
  );
};

export default EditorialButton; 